import { render, staticRenderFns } from "./WeForest.vue?vue&type=template&id=f00ef4d2&scoped=true&"
import script from "./WeForest.vue?vue&type=script&lang=js&"
export * from "./WeForest.vue?vue&type=script&lang=js&"
import style0 from "./WeForest.vue?vue&type=style&index=0&id=f00ef4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00ef4d2",
  null
  
)

export default component.exports